import { TransactionFile } from 'interfaces/TransactionFile';
import { RepositoryParams, api } from '..';

export type TransactionFilters = Partial<
  RepositoryParams & {
    type?: string;
  }
>;

export const list = async (params: TransactionFilters) => {
  return api.get('/realizado', { params });
};

export const create = async (params: TransactionFile) => {
  return api.post('/realizado', { ...params });
};

export const update = async (params: TransactionFile) => {
  return api.patch(`/realizado/${params.id}`, { ...params });
};

export const retrieve = async (id: string) => {
  return api.get(`/realizado/${id}`);
};

export const remove = async (id: string) => {
  return api.delete(`/realizado/${id}`);
};
